
import React from 'react';

interface IProps {
  style?: any;
  
}

export const TrashIcon:React.FC<IProps> = (props: IProps) => {
  return (
<svg width="16" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={props.style?.fillColor ? props.style.fillColor : "#fff"} d="M16 2.5v1a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 .5 2H5V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4.5a.5.5 0 0 1 .5.5zM1.87 18.14a2 2 0 0 0 2 1.86h8.28a2 2 0 0 0 2-1.86L15 6H1l.87 12.14z" />
</svg>



    
  )
}
